import request from "../../../helpers/request";

export const getLojas = async (idRegional: string, apikey?: boolean) => {

  try {

    const url = idRegional
    ? `/Loja/GetLojasIdRegional?idReg=${idRegional}`
    : `/Loja/GetLojas`
    const result = await request({ url })
    console.log("result", result);
    return result;
  } catch (err) {
    throw err
  }
}